import { NAME as PARENT_NAME } from '../constants';

export const NAME_FRAGMENT = 'input' as const;
export const NAME = `${PARENT_NAME}/${NAME_FRAGMENT}` as const;

export const SAMPLE_RATE = 16000;
